<div class="navigation">

    <Grid>

        <GridItem span="4-of-12">

            <nav class="page-navigation">

                <ul class="list list--inline">
    
                    <li>
                        
                        <Link to="/" activeClass="nav--active" exact>Home</Link>
                    
                    </li>
            
                    <li>
                        
                        <Link to="/blog" activeClass="nav--active">Blog</Link>
                    
                    </li>
            
                </ul>

            </nav>

        </GridItem>

        <GridItem span="8-of-12">

            <Breadcrumbs />

        </GridItem>

    </Grid>
        
</div>

<style>
    .navigation {
        color: var(--light);
        background-color: var(--black);
    }

    .page-navigation {
        overflow: hidden;
    }

    .page-navigation ul {
        margin: 0;
        padding: 0;
    }

    .page-navigation li {
        display: inline-block;
        margin: 0;
        padding: 0;
    }

    :global(.page-navigation a) {
        display: inline-block;
        /* background-color: var(--dark); */
        --icon-color: var(--light);
        padding: 1rem 2rem;
        color: var(--light);
    }

    :global(.page-navigation a:hover) {
        background-color: var(--dark);
        text-decoration: none;
    }
</style>

<script>
    // components
    import Link from 'components/Link.html'
    import Grid from 'components/Grid.html'
    import GridItem from 'components/GridItem.html'

    // views
    import Breadcrumbs from 'views/compounds/Breadcrumbs.html'

    export default {
        components: {
            Link,
            Grid,
            GridItem,
            Breadcrumbs
        },
        oncreate() {
            const createBreadcrumbs = (pathname) => {
                let breadcrumbs = []
                
                let url = '/'
                pathname.split('/').filter(Boolean).forEach(segment => {
                    url = `${url}/${segment}`

                    breadcrumbs.push({
                        title: segment,
                        url
                    })
                })

                return breadcrumbs 
            }

            const component = this
            const history = window.customHistory

            history.listen(location => {
                component.set({
                    breadcrumbs: createBreadcrumbs(location.pathname)
                })
            })

            component.set({
                breadcrumbs: createBreadcrumbs(history.location.pathname)
            })
        },
        data() {
            return {
                breadcrumbs: []
            }
        }
    }
</script>